module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_1.044c2911.png";